// Keep the debounce function and the modified rangeSlider library code from the previous response

// Modified function to initialize the "Show More" button behavior for elements within a specific container
// This function should be called on the initial page load (for the whole document)
// and then specifically on the facet containers that were updated via AJAX.
function initShowMoreButtons(container = document) {
  // Find all facet lists within the specified container
  const facetLists = container.querySelectorAll(".facets__list");

  facetLists.forEach((el) => {
    const showMoreButton = el.querySelector('.list-menu__show-more');

    // Check if the button exists and if the list has more than 4 children
    if (showMoreButton && el.childElementCount > 4) {
      // Prevent adding duplicate listeners if this function is accidentally called twice on the same element
      // Replacing innerHTML should prevent this for the replaced elements, but this adds robustness.
      if (!showMoreButton.dataset.showMoreInitialized) {
         showMoreButton.addEventListener("click", function() {
           // Toggle the class on the facet list element
           if (el.classList.toggle("facets__list-long")) {
             showMoreButton.innerText = "- Minder opties";
           } else {
             showMoreButton.innerText = "+ Meer opties";
           }
         });
         // Mark the button as having its listener initialized
         showMoreButton.dataset.showMoreInitialized = 'true';
      }
    } else if (showMoreButton && el.childElementCount <= 4) {
        // If the button exists but is no longer needed (<= 4 items), ensure it's hidden or removed.
        // Your CSS or server-rendered HTML should ideally handle this, but JS could hide it.
        // For now, we just ensure the listener isn't added if the condition isn't met.
        // If the button *should* be hidden/removed, ensure your server template does that.
    }
  });
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

// Nu ook op mobiel live feedback geven bij elke klik
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
// CRO FIX: Directe feedback + Submit voor Ratings/Prijzen
    facetForm.querySelectorAll('.facets__item a, .facets__item label:not(.facet-checkbox)').forEach(item => {
      item.addEventListener('click', (event) => {
        if (facetForm.id === 'FacetFiltersFormMobile') {
          // 1. Verwijder eerst 'active' van broertjes (voor het geval je van rating switcht)
          const parentList = item.closest('.facets__list');
          if (parentList) {
            parentList.querySelectorAll('.is-selected-loading').forEach(el => el.classList.remove('is-selected-loading'));
          }

          // 2. Voeg direct de 'loading/selected' class toe voor visuele bevestiging
          item.classList.add('is-selected-loading');

          // 3. Submit de boel
          setTimeout(() => {
            this.onSubmitHandler(event);
          }, 100);
        }
      });
    });

    // Add click handler for mobile "Bevestigen" button
    // Check for button inside form first
    const mobileSubmitButton = facetForm.querySelector('.facets-mobile-submit');
    if (mobileSubmitButton) {
      mobileSubmitButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSubmitHandler(event);
        const sidebar = document.getElementById('site-filters-sidebar');
        if (sidebar && sidebar.hide) {
          sidebar.hide();
        }
      });
    }

    // Use event delegation for button in sidebar footer (outside this element)
    const sidebar = this.closest('#site-filters-sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', (event) => {
        if (event.target.closest('.sidebar__footer .facets-mobile-submit')) {
          event.preventDefault();
          // Create a synthetic event with target inside the form so onSubmitHandler works
          const syntheticEvent = {
            preventDefault: () => {},
            target: facetForm
          };
          this.onSubmitHandler(syntheticEvent);
          if (sidebar.hide) {
            sidebar.hide();
          }
        }
      });
    }

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

static renderPage(searchParams, event, updateURLHash = true) {
  FacetFiltersForm.searchParamsPrev = searchParams;

  if (FacetFiltersForm.abortController) {
    FacetFiltersForm.abortController.abort();
  }

  FacetFiltersForm.abortController = new AbortController();

  const sections = FacetFiltersForm.getSections();
  const gridWrapper = document.getElementById('main-collection-product-grid');

  if (gridWrapper) {
    gridWrapper.classList.add('loading');
  }

  sections.forEach((section) => {
    const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event, FacetFiltersForm.abortController.signal);
  });

  if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
}

static renderSectionFromFetch(url, event, signal) {
  fetch(url, { signal })
    .then(response => response.text())
    .then((responseText) => {
      if (signal && signal.aborted) return;

      const html = responseText;

      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGrid(html);
      FacetFiltersForm.renderProductCount(html);
    })
    .catch((error) => {
      if (error.name !== 'AbortError') {
        console.error('Facet filtering failed:', error);
      }
    })
    .finally(() => {
      if (!signal || !signal.aborted) {
        const gridWrapper = document.getElementById('main-collection-product-grid');

        if (gridWrapper) {
          gridWrapper.classList.remove('loading');
        }
      }
    });
}

static renderSectionFromCache(filterDataUrl, event) {
  const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

  FacetFiltersForm.renderFilters(html, event);
  FacetFiltersForm.renderProductGrid(html);
  FacetFiltersForm.renderProductCount(html);

  const gridWrapper = document.getElementById('main-collection-product-grid');

  if (gridWrapper) {
    gridWrapper.classList.remove('loading');
  }
}

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('CollectionProductGrid').querySelectorAll('template').forEach(elm=>{
      elm.closest('form')?.append(elm.content.cloneNode(true));
    })
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
    if ( countEl ) {
      document.querySelectorAll('#CollectionProductCount').forEach(elm=>{
        elm.innerHTML = countEl.innerHTML;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? ( element.dataset.index === jsFilter.dataset.index && ! element.hasAttribute('data-and-operator') ) : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex); // This is the facet that triggered the update

    facetsToRender.forEach((element) => {
      // Find the existing element on the page that corresponds to this updated facet
        const existingElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

        if (existingElement) {
             // Replacing innerHTML removes old elements and creates new ones.
             // For custom elements like <price-range> and <facet-remove> within this HTML,
             // their disconnectedCallback should run, then connectedCallback for the new ones.
            existingElement.innerHTML = element.innerHTML;

             // **Re-initialize custom elements (like PriceRange) within the replaced HTML**
             // This is necessary because connectedCallback might need a push or
             // to ensure the initialization logic runs consistently after innerHTML replacement.
             // Query for custom elements *within* the element whose HTML was just replaced.
            existingElement.querySelectorAll('price-range').forEach(priceRangeEl => {
                 // Call the initialization method if it exists
                if (typeof priceRangeEl.initializePriceRange === 'function') {
                   priceRangeEl.initializePriceRange();
                } else if (typeof priceRangeEl.connectedCallback === 'function') {
                    // Fallback to calling connectedCallback if initializePriceRange is not a public method
                    priceRangeEl.connectedCallback();
                }
            });
            // Re-initialize any other custom elements that might need it (like facet-remove, although its constructor might be enough)
            existingElement.querySelectorAll('facet-remove').forEach(facetRemoveEl => {
                 // For facet-remove, the constructor attaching the click listener on creation
                 // should be sufficient after innerHTML replaces the element. No extra step needed unless issues arise.
            });


            // *** IMPORTANT FIX: Re-initialize "Show More" buttons ONLY for THIS replaced facet ***
            initShowMoreButtons(existingElement); // Run the initialization function on the replaced container

        }

    });

     // The facet that triggered the update (countsToRender) was NOT replaced.
     // Its existing custom elements (<price-range>, <facet-remove>) and their listeners (including "Meer opties" if applicable)
     // from the initial page load or a previous update are still present and should still be working.
     // We must NOT run initShowMoreButtons(event.target.closest('.js-filter')) here as it would add a duplicate listener.


    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // REMOVED: Do NOT call facetsEventListeners() or initShowMoreButtons(document) here.
     // Listeners have already been initialized on initial load,
     // and selectively re-initialized above for the replaced facets.
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) ) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.abortController = null;
customElements.define('facet-filters-form', FacetFiltersForm);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.submitTimer = null;
  }

  connectedCallback() {
    this.initializePriceRange();
  }

  initializePriceRange() {
    this.cleanUpEvents();

    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');

    if (!inputMin || !inputMax) return;

    const originalMin = this.getNumber(
      inputMin.getAttribute('data-original-min') ||
      inputMin.getAttribute('min') ||
      inputMin.getAttribute('placeholder') ||
      '0'
    );

    const originalMax = this.getNumber(
      inputMax.getAttribute('data-original-max') ||
      inputMax.getAttribute('max') ||
      inputMax.getAttribute('placeholder') ||
      '100'
    );

    if (!Number.isFinite(originalMin) || !Number.isFinite(originalMax) || originalMax <= originalMin) return;

    inputMin.setAttribute('data-original-min', originalMin.toString());
    inputMax.setAttribute('data-original-max', originalMax.toString());

    inputMin.setAttribute('min', originalMin.toString());
    inputMin.setAttribute('max', originalMax.toString());
    inputMax.setAttribute('min', originalMin.toString());
    inputMax.setAttribute('max', originalMax.toString());

    inputMin.inputMode = 'decimal';
    inputMax.inputMode = 'decimal';

    const priceFields = this.querySelector('.facets__price');

this.closest('.facets__display')?.classList.add('facets__display--price-range');
this.closest('.js-filter')?.classList.add('js-filter--price-range');

let sliderContainer = this.querySelector('[data-js-price-range-slider]');

if (!sliderContainer) {
  sliderContainer = document.createElement('div');
  sliderContainer.setAttribute('data-js-price-range-slider', '');
}

if (priceFields) {
  priceFields.before(sliderContainer);
} else {
  this.prepend(sliderContainer);
}

    sliderContainer.className = 'facets-price-range-slider';
    sliderContainer.innerHTML = `
      <div class="facets-price-range-slider__track">
        <div class="facets-price-range-slider__range"></div>
      </div>
      <input
        class="facets-price-range-slider__input facets-price-range-slider__input--min"
        type="range"
        aria-label="Minimum prijs"
      >
      <input
        class="facets-price-range-slider__input facets-price-range-slider__input--max"
        type="range"
        aria-label="Maximum prijs"
      >
    `;

    const minSlider = sliderContainer.querySelector('.facets-price-range-slider__input--min');
    const maxSlider = sliderContainer.querySelector('.facets-price-range-slider__input--max');

    const step = originalMax - originalMin <= 50 ? '0.5' : '1';

    [minSlider, maxSlider].forEach((slider) => {
      slider.min = originalMin.toString();
      slider.max = originalMax.toString();
      slider.step = step;
    });

    const currentMin = this.clamp(this.getNumber(inputMin.value, originalMin), originalMin, originalMax);
    const currentMax = this.clamp(this.getNumber(inputMax.value, originalMax), originalMin, originalMax);

    minSlider.value = Math.min(currentMin, currentMax).toString();
    maxSlider.value = Math.max(currentMin, currentMax).toString();

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    const updateVisuals = () => {
      const minValue = this.getNumber(minSlider.value, originalMin);
      const maxValue = this.getNumber(maxSlider.value, originalMax);

      const leftPercentage = ((minValue - originalMin) / (originalMax - originalMin)) * 100;
      const rightPercentage = 100 - (((maxValue - originalMin) / (originalMax - originalMin)) * 100);

      sliderContainer.style.setProperty('--price-range-left', `${leftPercentage}%`);
      sliderContainer.style.setProperty('--price-range-right', `${rightPercentage}%`);
    };

    const updateInputLimits = () => {
      inputMin.setAttribute('max', maxSlider.value);
      inputMax.setAttribute('min', minSlider.value);
    };

    const syncInputsFromSliders = (activeSlider) => {
      let minValue = this.getNumber(minSlider.value, originalMin);
      let maxValue = this.getNumber(maxSlider.value, originalMax);

      if (minValue > maxValue) {
        if (activeSlider === minSlider) {
          maxValue = minValue;
          maxSlider.value = maxValue.toString();
        } else {
          minValue = maxValue;
          minSlider.value = minValue.toString();
        }
      }

      inputMin.value = minValue <= originalMin ? '' : this.formatValue(minValue);
      inputMax.value = maxValue >= originalMax ? '' : this.formatValue(maxValue);

      updateInputLimits();
      updateVisuals();
    };

    const syncSlidersFromInputs = () => {
      let minValue = this.clamp(this.getNumber(inputMin.value, originalMin), originalMin, originalMax);
      let maxValue = this.clamp(this.getNumber(inputMax.value, originalMax), originalMin, originalMax);

      if (minValue > maxValue) {
        const changedInput = document.activeElement;

        if (changedInput === inputMin) {
          maxValue = minValue;
        } else {
          minValue = maxValue;
        }
      }

      minSlider.value = minValue.toString();
      maxSlider.value = maxValue.toString();

      inputMin.value = minValue <= originalMin ? '' : this.formatValue(minValue);
      inputMax.value = maxValue >= originalMax ? '' : this.formatValue(maxValue);

      updateInputLimits();
      updateVisuals();
    };

    minSlider.addEventListener('input', () => {
      syncInputsFromSliders(minSlider);
      this.scheduleSubmit(inputMin);
    }, { signal });

    maxSlider.addEventListener('input', () => {
      syncInputsFromSliders(maxSlider);
      this.scheduleSubmit(inputMax);
    }, { signal });

    inputMin.addEventListener('input', () => {
      syncSlidersFromInputs();
      this.scheduleSubmit(inputMin);
    }, { signal });

    inputMax.addEventListener('input', () => {
      syncSlidersFromInputs();
      this.scheduleSubmit(inputMax);
    }, { signal });

    inputMin.addEventListener('change', () => {
      syncSlidersFromInputs();
      this.scheduleSubmit(inputMin);
    }, { signal });

    inputMax.addEventListener('change', () => {
      syncSlidersFromInputs();
      this.scheduleSubmit(inputMax);
    }, { signal });

    syncInputsFromSliders(null);
  }

  scheduleSubmit(targetInput) {
    clearTimeout(this.submitTimer);

    this.submitTimer = setTimeout(() => {
      const facetForm = this.closest('facet-filters-form');

      if (!facetForm) return;

      facetForm.onSubmitHandler({
        target: targetInput,
        preventDefault: () => {}
      });
    }, 200);
  }

  getNumber(value, fallback = 0) {
    if (value === null || value === undefined || value === '') return fallback;

    const number = Number(String(value).replace(',', '.'));

    return Number.isFinite(number) ? number : fallback;
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  formatValue(value) {
    if (Number.isInteger(value)) return value.toString();

    return value.toFixed(2).replace(/\.?0+$/, '');
  }

  cleanUpEvents() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }

    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
      this.submitTimer = null;
    }
  }

  disconnectedCallback() {
    this.cleanUpEvents();
  }
}
customElements.define('price-range', PriceRange);

// *** INITIAL CALL ONLY ***
// Initialize "Show More" buttons for all facet lists on the initial page load
document.addEventListener("DOMContentLoaded", function() {
  initShowMoreButtons(document);
});